import { Component, ElementRef, Input } from '@angular/core';

@Component({
	selector: 'tx-blockable',
	template: `
		<div [ngStyle]="style" [ngClass]="class">
			<ng-content></ng-content>
		</div>
	`,
})
export class TxBlockableDivComponent {
	@Input() style: any;
	@Input() class: any;

	constructor(private el: ElementRef) {}

	getBlockableElement(): HTMLElement {
		return this.el.nativeElement.children[0];
	}
}
